export default __webpack_public_path__ + "static/media/red.09ffe5d9.png";